<template>
  <EBody :style="body">
    <ESection
      v-if="!item.image_src"
      :style="{
        backgroundColor: '#00000005',
        border: '1px dashed #00000026',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '20px',
        padding: '20px 0',
        width: 'auto',
      }"
    >
      <EText :style="{ fontSize: '25px', textAlign: 'center', marginBottom: '8px' }">
        <PictureOutlined />
      </EText>
      <EText :style="{ color: '#262626E0', margin: '0', marginBottom: '4px' }">
        Aquí se visualizará tu imagen
      </EText>
      <EText :style="{ fontSize: '12px', color: '#595959', margin: '0', textAlign: 'center' }">
        Solo se aceptan JPG, JPEG, PNG.
        <br />
        (Max. 5MB)
      </EText>
    </ESection>

    <ESection
      v-else
      :style="{
        padding: '20px',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: flexJustifyContent(item.alignment),
      }"
    >
      <ELink v-if="item.url" :href="item.url">
        <EImg
          :style="{ maxWidth: '100%' }"
          :src="item.image_src"
          :width="item.width"
          :height="item.height"
          :alt="`image-${item.id}`"
        />
      </ELink>

      <EImg
        v-else
        :style="{ maxWidth: '100%' }"
        :src="item.image_src"
        :width="item.width"
        :height="item.height"
        :alt="`image-${item.id}`"
      />
    </ESection>
  </EBody>
</template>

<script setup lang="ts">
import { EBody, EImg, ELink, ESection, EText } from "vue-email";
import { PictureOutlined } from "@ant-design/icons-vue";

import { body } from "@/app/flows/emailTemplates/utils/defaultStyles";
import { ImageItem, ItemAlignment } from "@/@types/flows/emailTemplates/items";

defineProps<{ item: ImageItem }>();

const flexJustifyContent = (alignment: ItemAlignment) => {
  if (alignment === ItemAlignment.Center) return "center";
  if (alignment === ItemAlignment.Right) return "flex-end";
  return "flex-start";
};
</script>

<style scoped lang="sass"></style>
